import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ProfileStepHeader } from './ProfileStepHeader';
import { ProfileSettingsSection } from '../profile/ProfileSettingsSection';
import { useProfileStore } from '../../stores/profileStore';

interface ImproveProfileStepProps {
  onComplete?: () => void;
}

const ImproveProfileStep: React.FC<ImproveProfileStepProps> = ({ onComplete }) => {
  const { t } = useTranslation('auth');
  const { profile } = useProfileStore();
  const navigate = useNavigate();

  const handleComplete = () => {
    if (onComplete) {
      onComplete();
    } else {
      navigate('/dashboard', { replace: true });
    }
  };

  return (
    <div className="flex flex-col md:min-h-[calc(100vh-4rem)] md:px-8 lg:px-[9.38rem]">
      <div className="w-full md:w-2/3 pt-28 md:pr-8 flex flex-col">
        <ProfileStepHeader
          firstName={profile?.first_name || ''}
          welcome={t('improveProfileStep.welcome')}
          completeSignup={t('completeSignup')}
          step={t('improveProfileStep.step')}
          completeInfo={t('improveProfileStep.completeInfo')}
          stepDesc={t('improveProfileStep.stepDesc')}
        />
      </div>
      <div className="my-8 md:my-16">
        <ProfileSettingsSection isOnboarding={true} onComplete={handleComplete} />
      </div>
    </div>
  );
};

export default ImproveProfileStep;
